module.exports = __webpack_public_path__ + "static/media/mlh-logo.82d8be29.png";